/*
 * Copyright (c) 2025. Dave van Rijn Development
 */

import React, {PropsWithChildren, useState} from 'react';
import {ContextConfig, ContextShape} from '../../interfaces';
import User from '../../models/userModel';

const defaultContext: ContextShape = {
    user: null,
    onChangeContext: () => {
    }
};
export const AppContext = React.createContext(defaultContext);

export default function AppContextProvider(props: PropsWithChildren<{}>) {
    const [context, setContext] = useState<ContextShape>({user: null, onChangeContext});

    function onChangeContext(config: ContextConfig, callback?: VoidFunction) {
        setContext((currentContext: ContextShape) => ({...currentContext, ...config}));
        if (callback) window.setTimeout(callback);
    }

    return (
        <AppContext.Provider value={context}>
            {props.children}
        </AppContext.Provider>
    );
}
